"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyRecommenderRequest = void 0;
var MyRecommenderRequest = /** @class */ (function () {
    function MyRecommenderRequest() {
    }
    return MyRecommenderRequest;
}());
exports.MyRecommenderRequest = MyRecommenderRequest;
;
//# sourceMappingURL=myRecommender.request.js.map